export default __webpack_public_path__ + "media/images/plus-b2fcc35a2a973649da9d241fda4b6add.png";